<template>
  <el-dialog
    title="Оценивающие"
    :visible.sync="show"
    top="2vh"
    :close-on-click-modal="false"
    width="75%"
  >
    <div v-loading="loading">
      <div style="margin-bottom: 25px">
        <search-input
          placeholder="Поиск по ФИО"
          style="width: 300px"
          v-model="filters.search"
          @change="filtersChanged"
        >
        </search-input>
        <eval-evaluator-status-select
          v-model="filters.statuses"
          @change="filtersChanged"
        ></eval-evaluator-status-select>
        <eval-evaluator-type-select
          v-if="type === 'all'"
          v-model="filters.types"
          @change="filtersChanged"
        ></eval-evaluator-type-select>
        <el-button
          v-if="type === 'colleague' && evaluation.status !== 'finished'"
          style="position: absolute; right: 20px"
          type="primary"
          size="small"
          icon="fas fa-plus"
          @click="openAddDialog"
        >
          Добавить ещё коллег
        </el-button>
      </div>
      <el-table :data="evaluators" border>
        <el-table-column width="150" prop="user.persnum" label="Перс. №"></el-table-column>
        <el-table-column prop="user.full_name" label="ФИО"></el-table-column>
        <el-table-column prop="user.email" label="Email"></el-table-column>
        <el-table-column width="320" label="Статус">
          <template v-slot="scope">
            <span class="status" :class="scope.row.status === 'evaluated' ? 'done' : 'in_progress'">{{ scope.row.status_label }}</span>
          </template>
        </el-table-column>
        <el-table-column width="300" prop="type_label" label="Тип"></el-table-column>
        <el-table-column width="120" label="Напоминание" v-if="evaluation.status !== 'finished'">
          <template v-slot="scope">
            <eval-remind-button :data="scope.row" :evaluation="evaluation"></eval-remind-button>
          </template>
        </el-table-column>
      </el-table>
      <paginator
        :paginator.sync="paginator"
        use-router-query-param
        @page-changed="loadEvaluators"
      ></paginator>

      <add-eval-colleagues-dialog
        ref="addDialog"
        :all="true"
        :user_id="evaluateeId"
        :evaluation="evaluation"
        @load-evaluators="loadEvaluators(true)"
      >
      </add-eval-colleagues-dialog>
    </div>
  </el-dialog>
</template>

<script>
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import EvalEvaluatorStatusSelect from "@/modules/evaluation/components/EvalEvaluatorStatusSelect.vue";
import EvalEvaluatorTypeSelect from "@/modules/evaluation/components/EvalEvaluatorTypeSelect.vue";
import EvalRemindButton from "@/modules/evaluation/components/EvalRemindButton.vue";
import AddEvalColleaguesDialog from "@/modules/evaluation/components/myEvaluation/AddEvalColleaguesDialog.vue";

export default {
  name: "eval-evaluation-evaluators-show-dialog",
  components: {
    AddEvalColleaguesDialog,
    EvalRemindButton,
    EvalEvaluatorTypeSelect,
    EvalEvaluatorStatusSelect,
    SearchInput,
    Paginator
  },
  mixins: [paginator],
  beforeMount() {
    this.paginator.perPage = 10;
  },
  data() {
    return {
      loading: false,
      type: null,
      evaluateeId: null,
      evaluators: [],
      evaluation: {},
      show: false,
      filters: {},
    }
  },
  methods: {
    async open(type, evaluateeId, evaluation) {
      this.evaluation = evaluation;
      this.type = type;
      this.evaluateeId = evaluateeId;
      this.loadEvaluators();
      this.show = true;
    },
    close() {
      this.show = false;
    },
    openAddDialog() {
      this.$refs.addDialog.open();
    },
    loadEvaluators(reloadEvaluationEvaluators = false) {
      this.loading = true;

      if (reloadEvaluationEvaluators) {
        this.$emit('load-evaluation-evaluators');
      }

      this.$api.evaluation.evaluatorsSearch({
        ...this.filters,
        types: this.type !== 'all' ? [this.type] : this.filters.types,
        evaluatee_id: this.evaluateeId,
        evaluation_id: this.$route.params.id,
        expand: ['user'].join(),
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.evaluators = data.evaluators;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    filtersChanged() {
      this.loadEvaluators();
    },
  }
}
</script>

<style>
  .status {
    color: white;
    margin: 5px;
    border-radius: 10px;
    padding: 5px 10px;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
  }

  .status.done {
    background-color: #64d074;
  }

  .status.in_progress {
    background-color: #f3ae7b;
  }
</style>